import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field, change, formValueSelector} from 'redux-form';
import {InputField, DropdownField} from '../../../common/components/form';
import {Card, Grid} from 'semantic-ui-react';
import {MANAGE_COLORS_FORM} from '../../../common/forms';
import './editColorData.scss';

const statusOptions = [
  {'text': 'Activo', 'value': 'A'},
  {'text': 'Inactivo', 'value': 'I'},
];
const typeOptions = [
  {'text': 'Interior', 'value': 'I'},
  {'text': 'Exterior', 'value': 'E'},
];

class ColorData extends Component {
  render() {
    const {addColor} = this.props;
    return (
      <div>
        <Card raised fluid className='manage-colors-form'>
          <Grid textAlign='left'>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Código Color</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                <Field
                  name='colorCode'
                  component={InputField}
                  maxLength={3}
                  normalize={(value) => value.toUpperCase()}
                  disabled={!addColor}
                  invalidMessage='Por favor, llene este campo'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Tipo</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                <Field
                  name='type'
                  component={DropdownField}
                  options={typeOptions}
                  disabled={!addColor}
                  invalidMessage='Por favor, seleccione una opción'
                  required
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Descripción</h4>
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  name='colorDescription'
                  component={InputField}
                  maxLength={30}
                  normalize={(value) => value.toUpperCase()}
                  disabled={!addColor}
                  invalidMessage='Por favor, llene este campo'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Descripción en Inglés</h4>
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  name='specialDescription'
                  component={InputField}
                  maxLength={10}
                  normalize={(value) => value.toUpperCase()}
                  disabled={!addColor}
                  invalidMessage='Por favor, llene este campo'
                  required
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Estado</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                <Field
                  name='status'
                  component={DropdownField}
                  options={statusOptions}
                  defaultValue={statusOptions[0]}
                  disabled
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const formValues = formValueSelector(MANAGE_COLORS_FORM.name);
  const colorCode = formValues(state, 'colorCode');
  const type = formValues(state, 'type');
  const colorDescription = formValues(state, 'colorDescription');
  const specialDescription = formValues(state, 'specialDescription');
  const status = formValues(state, 'status');
  const udcJdeSy = formValues(state, 'udcJdeSy');
  const udcJdeRt = formValues(state, 'udcJdeRt');
  return {
    'permissions': state.session.permissions,
    colorCode,
    type,
    colorDescription,
    specialDescription,
    status,
    udcJdeSy,
    udcJdeRt,
  };
};

export default connect(mapStateToProps, {
  change,
})(ColorData);
